'use strict';

module.exports = process.env.DATAYOGI === '1';
